import React from "react";
import { Link } from "react-router-dom";
import { URLS } from "../_config";
import { useUserApi } from "../store/api/hooks/userApiHook";
import Toggle from "./ToggleSwitch";
import OnlineOfflineToggle from "./ToggleSwitch";
import ToggleSwitch from "./ToggleSwitch";
import { Dropdown } from "react-bootstrap";
import { useUser } from "../store/api/hooks/authHook";

const Header: React.FC = () => {
  const userAPI: any = useUserApi();
  const userData: any = useUser();

  const logout = () => {
    console.log('Hello');
    userAPI.logout({},
      (message: any, resp: any) => { },
      (message: any, error: any) => { }
    );
  };

  const toggleMenu = () => {
    let body = document.querySelector("body");
    body?.classList.toggle("sidebar-enable");
    body?.classList.toggle("vertical-collpsed");
  };
  const handleToggle = (state: boolean) => {
    console.log("Toggle state:", state);
  };
  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to={URLS.HOME} className="logo logo-dark">
              <span className="logo-sm">
                <img src="assets/images/logo.svg" alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo-dark.png" alt="" height="17" />
              </span>
            </Link>

            <Link to={URLS.HOME} className="logo logo-light">
              <span className="logo-sm">
                <img src="assets/images/logo-icon.png" alt="" />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo.png" alt="" height="50" />
              </span>
            </Link>
          </div>

          <button
            type="button"
            className="btn btn-sm px-3 font-size-16 header-item waves-effect"
            id="vertical-menu-btn"
            onClick={toggleMenu}
          >
            <i className="bars-icon"></i>
          </button>
        </div>

        <div className="d-flex align-items-center">
          <div className="dropdown d-inline-block d-lg-none ml-2">
            <button
              type="button"
              className="btn header-item noti-icon waves-effect"
              id="page-header-search-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="mdi mdi-magnify"></i>
            </button>
            <div
              className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
              aria-labelledby="page-header-search-dropdown"
            >
              <form className="p-3">
                <div className="form-group m-0">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search ..."
                      aria-label="Recipient's username"
                    />
                    <div className="input-group-append">
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="off-on-toggle d-flex align-items-center">
            <ToggleSwitch
              onlineText="Online"
              offlineText="Offline"
              onlineColor="#008080"
              offlineColor="#333333"
              initialState={false}
              onToggle={handleToggle}
            />
          </div>
          <Link to={URLS.FUNDING.SUBMIT_REQUEST} className="btn btn-light-secondary w-md">
            Add a Loan Request
          </Link>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle
              variant="link"
              id="page-header-notifications-dropdown"
              className="btn header-item noti-icon waves-effect"
            >
              <i className="noti-bell">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clipPath="url(#clip0_15_159)"> <rect width="24" height="24" fill="white"></rect> <path d="M9.5 19C8.89555 19 7.01237 19 5.61714 19C4.87375 19 4.39116 18.2177 4.72361 17.5528L5.57771 15.8446C5.85542 15.2892 6 14.6774 6 14.0564C6 13.2867 6 12.1434 6 11C6 9 7 5 12 5C17 5 18 9 18 11C18 12.1434 18 13.2867 18 14.0564C18 14.6774 18.1446 15.2892 18.4223 15.8446L19.2764 17.5528C19.6088 18.2177 19.1253 19 18.382 19H14.5M9.5 19C9.5 21 10.5 22 12 22C13.5 22 14.5 21 14.5 19M9.5 19C11.0621 19 14.5 19 14.5 19" stroke="#000000" stroke-linejoin="round"></path> <path d="M12 5V3" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path> </g> <defs> <clipPath id="clip0_15_159"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </g></svg>
              </i>
              <span className="badge bg-danger rounded-pill">3</span>
            </Dropdown.Toggle>


          </Dropdown>

          <Dropdown className="d-inline-block">
            <Dropdown.Toggle
              variant="link"
              id="page-header-user-dropdown"
              className="btn header-item waves-effect"
            >
              <img className="rounded-circle header-profile-user" src={userData?.avatar?.thumb} alt={userData?.first_name} />
              <span className="d-none d-xl-inline-block ml-1">{userData?.first_name}</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item href="#">
                <i className="bx bx-user font-size-16 align-middle mr-1"></i>{" "}
                <span>Profile</span>
              </Dropdown.Item>
              <Dropdown.Item href="#">
                <i className="bx bx-wallet font-size-16 align-middle mr-1"></i>{" "}
                <span>My Wallet</span>
              </Dropdown.Item>
              <Dropdown.Item href="#">
                <span className="badge bg-success float-end">11</span>
                <i className="bx bx-wrench font-size-16 align-middle mr-1"></i>{" "}
                <span>Settings</span>
              </Dropdown.Item>
              <Dropdown.Item href="#">
                <i className="bx bx-lock-open font-size-16 align-middle mr-1"></i>{" "}
                <span>Lock screen</span>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={logout} className="text-danger">
                <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>{" "}
                <span>Logout</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default Header;
